import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="11" fill="currentColor" />
    <path
      d="M4.18323 11.9408L17.6514 6.0218C17.8418 5.93836 18.0476 6.10793 17.9902 6.30173L14.8822 16.7588C14.8416 16.8975 14.682 16.9688 14.5462 16.9096L11.2939 15.5207C11.1651 15.4655 11.0139 15.526 10.9635 15.6539L10.1081 17.8463C10.0213 18.0697 9.6853 18.0428 9.6363 17.8099L8.99789 14.7428C8.98109 14.6647 9.00769 14.5853 9.06509 14.5288L14.0954 9.69322C14.1416 9.64881 14.0772 9.58017 14.0268 9.6192L8.04728 13.6876C7.84568 13.8249 7.58527 13.8532 7.35707 13.7617L4.18323 12.4885C3.93962 12.3822 3.93822 12.0484 4.18323 11.9408Z"
      fill="white"
    />
  </svg>
);
